// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/ryugu/v1/contract_model.proto (package mono.ryugu.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { AddGlossaryRelationRequest, AddGlossaryRelationResponse, AddOccurrenceRequest, AddOccurrenceResponse, ApproveOccurrenceDecisionRequest, ApproveOccurrenceDecisionResponse, BindGlossaryTermRequest, BindGlossaryTermResponse, CreateDutyRequest, CreateDutyResponse, CreateScheduleRuleRequest, CreateScheduleRuleResponse, CreateSowRequest, CreateSowResponse, CreateSubmissionRequest, CreateSubmissionResponse, CreateWorkstreamRequest, CreateWorkstreamResponse, DeleteDutyRequest, DeleteDutyResponse, DeleteScheduleRuleRequest, DeleteScheduleRuleResponse, GetDeliverableSettingsRequest, GetDeliverableSettingsResponse, GetDutyRequest, GetDutyResponse, GetOccurrenceRequest, GetOccurrenceResponse, GetProgramGlossaryRequest, GetProgramGlossaryResponse, GetWorkstreamRequest, GetWorkstreamResponse, ImportTrackerRequest, ImportTrackerResponse, LinkWorkstreamLineageRequest, LinkWorkstreamLineageResponse, ListDutiesRequest, ListDutiesResponse, ListOccurrenceDecisionsRequest, ListOccurrenceDecisionsResponse, ListOccurrencesRequest, ListOccurrencesResponse, ListWorkstreamsRequest, ListWorkstreamsResponse, LogContractEventRequest, LogContractEventResponse, MoveOccurrenceRequest, MoveOccurrenceResponse, ProposeOccurrenceNotOwedRequest, ProposeOccurrenceNotOwedResponse, ProposeOccurrenceWaiverRequest, ProposeOccurrenceWaiverResponse, RecordReviewRequest, RecordReviewResponse, RejectGlossaryRelationRequest, RejectGlossaryRelationResponse, RejectGlossaryTermRequest, RejectGlossaryTermResponse, RejectOccurrenceDecisionRequest, RejectOccurrenceDecisionResponse, RekindGlossaryTermRequest, RekindGlossaryTermResponse, RemoveOccurrenceRequest, RemoveOccurrenceResponse, RuleSowGapRequest, RuleSowGapResponse, SetDutyAssignmentRequest, SetDutyAssignmentResponse, SetExerciseWorkstreamRequest, SetExerciseWorkstreamResponse, UpdateDeliverableSettingsRequest, UpdateDeliverableSettingsResponse, UpdateDutyRequest, UpdateDutyResponse, UpdateScheduleRuleRequest, UpdateScheduleRuleResponse, UpdateSubmissionRequest, UpdateSubmissionResponse, UpdateWorkstreamRequest, UpdateWorkstreamResponse, WithdrawSubmissionRequest, WithdrawSubmissionResponse } from "./contract_model_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * ContractModelService is the browser door onto contract model v2's verbs
 * (plan S3b). ryugu authorizes every call and forwards its body, with the
 * signed-in user (connectutil.ForwardPrincipal), to pangaea's
 * ContractModelGatewayService, which owns the rows and the rules. Each
 * message wraps pangaea's own as `body`: those carry no tenant or actor
 * (R8), so the browser sends them as they are.
 *
 * Authorization (D111):
 *   - reads: the program read projection;
 *   - writes: the `execution` write area on the program (area:execution);
 *   - RecordReview: area:execution.verdict, recording the government's
 *     verdict, granted apart from doing the work;
 *   - RuleSowGap: change_set:commit (D94), on a program the caller can see;
 *   - UpdateDeliverableSettings: area:programs;
 *   - waiving a date or marking one not owed: dual control. The direct
 *     verbs are not on this service; one user proposes, a different user
 *     approves (ApproveOccurrenceDecision applies it), and
 *     RejectOccurrenceDecision ends a proposal (withdrawn by its proposer,
 *     rejected by anyone else; D112).
 *
 * @generated from service mono.ryugu.v1.ContractModelService
 */ export const ContractModelService = {
    typeName: "mono.ryugu.v1.ContractModelService",
    methods: {
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.CreateDuty
     */ createDuty: {
            name: "CreateDuty",
            I: CreateDutyRequest,
            O: CreateDutyResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.UpdateDuty
     */ updateDuty: {
            name: "UpdateDuty",
            I: UpdateDutyRequest,
            O: UpdateDutyResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.DeleteDuty
     */ deleteDuty: {
            name: "DeleteDuty",
            I: DeleteDutyRequest,
            O: DeleteDutyResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.GetDuty
     */ getDuty: {
            name: "GetDuty",
            I: GetDutyRequest,
            O: GetDutyResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ListDuties
     */ listDuties: {
            name: "ListDuties",
            I: ListDutiesRequest,
            O: ListDutiesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.CreateScheduleRule
     */ createScheduleRule: {
            name: "CreateScheduleRule",
            I: CreateScheduleRuleRequest,
            O: CreateScheduleRuleResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.UpdateScheduleRule
     */ updateScheduleRule: {
            name: "UpdateScheduleRule",
            I: UpdateScheduleRuleRequest,
            O: UpdateScheduleRuleResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.DeleteScheduleRule
     */ deleteScheduleRule: {
            name: "DeleteScheduleRule",
            I: DeleteScheduleRuleRequest,
            O: DeleteScheduleRuleResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.AddOccurrence
     */ addOccurrence: {
            name: "AddOccurrence",
            I: AddOccurrenceRequest,
            O: AddOccurrenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.RemoveOccurrence
     */ removeOccurrence: {
            name: "RemoveOccurrence",
            I: RemoveOccurrenceRequest,
            O: RemoveOccurrenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.MoveOccurrence
     */ moveOccurrence: {
            name: "MoveOccurrence",
            I: MoveOccurrenceRequest,
            O: MoveOccurrenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ProposeOccurrenceWaiver
     */ proposeOccurrenceWaiver: {
            name: "ProposeOccurrenceWaiver",
            I: ProposeOccurrenceWaiverRequest,
            O: ProposeOccurrenceWaiverResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ProposeOccurrenceNotOwed
     */ proposeOccurrenceNotOwed: {
            name: "ProposeOccurrenceNotOwed",
            I: ProposeOccurrenceNotOwedRequest,
            O: ProposeOccurrenceNotOwedResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ApproveOccurrenceDecision
     */ approveOccurrenceDecision: {
            name: "ApproveOccurrenceDecision",
            I: ApproveOccurrenceDecisionRequest,
            O: ApproveOccurrenceDecisionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.RejectOccurrenceDecision
     */ rejectOccurrenceDecision: {
            name: "RejectOccurrenceDecision",
            I: RejectOccurrenceDecisionRequest,
            O: RejectOccurrenceDecisionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ListOccurrenceDecisions
     */ listOccurrenceDecisions: {
            name: "ListOccurrenceDecisions",
            I: ListOccurrenceDecisionsRequest,
            O: ListOccurrenceDecisionsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.GetOccurrence
     */ getOccurrence: {
            name: "GetOccurrence",
            I: GetOccurrenceRequest,
            O: GetOccurrenceResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ListOccurrences
     */ listOccurrences: {
            name: "ListOccurrences",
            I: ListOccurrencesRequest,
            O: ListOccurrencesResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.LogContractEvent
     */ logContractEvent: {
            name: "LogContractEvent",
            I: LogContractEventRequest,
            O: LogContractEventResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.CreateWorkstream
     */ createWorkstream: {
            name: "CreateWorkstream",
            I: CreateWorkstreamRequest,
            O: CreateWorkstreamResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.UpdateWorkstream
     */ updateWorkstream: {
            name: "UpdateWorkstream",
            I: UpdateWorkstreamRequest,
            O: UpdateWorkstreamResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.GetWorkstream
     */ getWorkstream: {
            name: "GetWorkstream",
            I: GetWorkstreamRequest,
            O: GetWorkstreamResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ListWorkstreams
     */ listWorkstreams: {
            name: "ListWorkstreams",
            I: ListWorkstreamsRequest,
            O: ListWorkstreamsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.LinkWorkstreamLineage
     */ linkWorkstreamLineage: {
            name: "LinkWorkstreamLineage",
            I: LinkWorkstreamLineageRequest,
            O: LinkWorkstreamLineageResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.CreateSow
     */ createSow: {
            name: "CreateSow",
            I: CreateSowRequest,
            O: CreateSowResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.SetExerciseWorkstream
     */ setExerciseWorkstream: {
            name: "SetExerciseWorkstream",
            I: SetExerciseWorkstreamRequest,
            O: SetExerciseWorkstreamResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.SetDutyAssignment
     */ setDutyAssignment: {
            name: "SetDutyAssignment",
            I: SetDutyAssignmentRequest,
            O: SetDutyAssignmentResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.RuleSowGap
     */ ruleSowGap: {
            name: "RuleSowGap",
            I: RuleSowGapRequest,
            O: RuleSowGapResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.CreateSubmission
     */ createSubmission: {
            name: "CreateSubmission",
            I: CreateSubmissionRequest,
            O: CreateSubmissionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.UpdateSubmission
     */ updateSubmission: {
            name: "UpdateSubmission",
            I: UpdateSubmissionRequest,
            O: UpdateSubmissionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.WithdrawSubmission
     */ withdrawSubmission: {
            name: "WithdrawSubmission",
            I: WithdrawSubmissionRequest,
            O: WithdrawSubmissionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.RecordReview
     */ recordReview: {
            name: "RecordReview",
            I: RecordReviewRequest,
            O: RecordReviewResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.ImportTracker
     */ importTracker: {
            name: "ImportTracker",
            I: ImportTrackerRequest,
            O: ImportTrackerResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.GetDeliverableSettings
     */ getDeliverableSettings: {
            name: "GetDeliverableSettings",
            I: GetDeliverableSettingsRequest,
            O: GetDeliverableSettingsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.UpdateDeliverableSettings
     */ updateDeliverableSettings: {
            name: "UpdateDeliverableSettings",
            I: UpdateDeliverableSettingsRequest,
            O: UpdateDeliverableSettingsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Program glossary reviewer surface (SAD-716 S5b-2 B). Upsert stays on
     * pangaea (reverie). Edits require change_set:commit (D94/D111).
     *
     * @generated from rpc mono.ryugu.v1.ContractModelService.GetProgramGlossary
     */ getProgramGlossary: {
            name: "GetProgramGlossary",
            I: GetProgramGlossaryRequest,
            O: GetProgramGlossaryResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.RekindGlossaryTerm
     */ rekindGlossaryTerm: {
            name: "RekindGlossaryTerm",
            I: RekindGlossaryTermRequest,
            O: RekindGlossaryTermResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.RejectGlossaryTerm
     */ rejectGlossaryTerm: {
            name: "RejectGlossaryTerm",
            I: RejectGlossaryTermRequest,
            O: RejectGlossaryTermResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.RejectGlossaryRelation
     */ rejectGlossaryRelation: {
            name: "RejectGlossaryRelation",
            I: RejectGlossaryRelationRequest,
            O: RejectGlossaryRelationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.AddGlossaryRelation
     */ addGlossaryRelation: {
            name: "AddGlossaryRelation",
            I: AddGlossaryRelationRequest,
            O: AddGlossaryRelationResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.ryugu.v1.ContractModelService.BindGlossaryTerm
     */ bindGlossaryTerm: {
            name: "BindGlossaryTerm",
            I: BindGlossaryTermRequest,
            O: BindGlossaryTermResponse,
            kind: MethodKind.Unary
        }
    }
};
